export default __webpack_public_path__ + "static/media/blogging.55064fd3.png";